/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelStopWithDetention.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/stop-with-detention";

export class AutogenModelStopWithDetention<RowType extends ModelRow> extends Endpoint<RowType, RowStopWithDetentionFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowStopWithDetention extends ModelRow<RowStopWithDetentionFields> {
	constructor(values?: Partial<RowStopWithDetentionFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowStopWithDetentionFields {
	actual_arrival: Date;
	actual_departure: Date;
	address: string;
	address2: string;
	appointment_status_id: string;
	appt_contact_name: string;
	appt_required: string;
	cases: number;
	city_id: number;
	city_name: string;
	company_id: string;
	confirmed: string;
	contact_email: string;
	contact_name: string;
	"detention_hist.actual_arrival": Date;
	"detention_hist.actual_departure": Date;
	"detention_hist.arrive_msg_id": number;
	"detention_hist.authorization_num": string;
	"detention_hist.authorization_status": string;
	"detention_hist.bill_approved": string;
	"detention_hist.billing_approval": string;
	"detention_hist.comments": string;
	"detention_hist.commodity_id": string;
	"detention_hist.company_id": string;
	"detention_hist.create_charge": string;
	"detention_hist.creation_date": Date;
	"detention_hist.customer_id": string;
	"detention_hist.depart_msg_id": number;
	"detention_hist.detention_def_id": string;
	"detention_hist.driver2_id": string;
	"detention_hist.driver_id": string;
	"detention_hist.free_time_end": Date;
	"detention_hist.free_time_starts": Date;
	"detention_hist.id": string;
	"detention_hist.loaded_time": Date;
	"detention_hist.movement_id": string;
	"detention_hist.name": string;
	"detention_hist.notify_arrival_dt": Date;
	"detention_hist.notify_charge_dt": Date;
	"detention_hist.notify_depart_dt": Date;
	"detention_hist.notify_warn_dt": Date;
	"detention_hist.order_id": string;
	"detention_hist.pay_approval": string;
	"detention_hist.pay_free_time_end": Date;
	"detention_hist.require_auth": string;
	"detention_hist.sched_arrival": Date;
	"detention_hist.sched_arrive_early": Date;
	"detention_hist.sched_arrive_late": Date;
	"detention_hist.showas_address": string;
	"detention_hist.showas_address2": string;
	"detention_hist.showas_city_id": number;
	"detention_hist.showas_city_name": string;
	"detention_hist.showas_location_id": string;
	"detention_hist.showas_location_name": string;
	"detention_hist.showas_state": string;
	"detention_hist.showas_zip_code": string;
	"detention_hist.status": string;
	"detention_hist.stop_address": string;
	"detention_hist.stop_city_id": number;
	"detention_hist.stop_city_name": string;
	"detention_hist.stop_id": string;
	"detention_hist.stop_latitude": number;
	"detention_hist.stop_location_id": string;
	"detention_hist.stop_location_name": string;
	"detention_hist.stop_longitude": number;
	"detention_hist.stop_movement_sequence": number;
	"detention_hist.stop_state": string;
	"detention_hist.stop_type": string;
	"detention_hist.stop_zip_code": string;
	"detention_hist.tractor_id": string;
	"detention_hist.trailer_id": string;
	dist_from_prev: number;
	dist_from_prev_um: string;
	driver_load_unload: string;
	edi_code: string;
	edi_loc_code: string;
	eta: Date;
	eta_distance: number;
	eta_late: string;
	eta_oor: string;
	google_place_id: string;
	grouped_id: number;
	hub: number;
	ic_stop_id: string;
	id: string;
	inbound_status: string;
	late_eta_colorcode: string;
	late_route_status: string;
	latitude: number;
	location_id: string;
	location_name: string;
	longitude: number;
	manifest_fgp_uid: number;
	manifest_reg_uid: number;
	move_dist_from_preassign: number;
	move_dist_from_preassign_um: string;
	move_dist_from_previous: number;
	move_dist_from_previous_um: string;
	movement_id: string;
	movement_sequence: number;
	operational_status: string;
	order_id: string;
	order_sequence: number;
	orig_sched_early: Date;
	orig_sched_late: Date;
	pallets_dropped: number;
	pallets_picked_up: number;
	payment_code_reviewed: string;
	phone: string;
	planned_arrival_time: Date;
	ponum: string;
	prior_uncleared_stops: string;
	projected_arrival: Date;
	pu_override_arrive_early: Date;
	pu_override_arrive_late: Date;
	rate_dist_from_previous: number;
	rate_dist_from_previous_um: string;
	refno: string;
	requested_service: string;
	sched_arrive_early: Date;
	sched_arrive_late: Date;
	seal: string;
	service_date: Date;
	showas_address: string;
	showas_address2: string;
	showas_city_id: number;
	showas_city_name: string;
	showas_location_id: string;
	showas_location_name: string;
	showas_state: string;
	showas_zip_code: string;
	signed_for_name: string;
	state: string;
	status: string;
	stop_type: string;
	trimble_place_id: string;
	txl_uid: number;
	volume: number;
	volume_um: string;
	weight: number;
	weight_um: string;
	zip_code: string;
	zone_id: string;
}

